import { useEffect, useState } from "react";
import Layout from "./layout";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addSelectedPrestation, clearSelectedPrestations, fetchReservationById } from "../../store/slices/rendezVousSlice";
import { fetchEtablissementById, setSelectedEtablissement } from "../../store/slices/etablissementSlice";
import Confirmation from "../../components/confirmation";
import ConfirmBloc from "./confirmBloc";
import PrestationsConfirmBloc from "./prestationConfirmPage";
import { Helmet, HelmetProvider } from "react-helmet-async";

const ConfirmPageRendezVous = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const etablissement = useSelector(
    (state) => state.etablissements.selectedEtablissement
  );
  const { selectedPrestations, currentReservation, currentReservationStatus } =
    useSelector((state) => state.rendezvous);

  useEffect(() => {
    dispatch(fetchReservationById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (
      currentReservationStatus === "succeeded" &&
      currentReservation?.etablissement_id
    ) {
      dispatch(fetchEtablissementById(currentReservation.etablissement_id));
    }
  }, [currentReservationStatus, currentReservation, dispatch]);

  const buttonAction = (prestation) => {
    dispatch(clearSelectedPrestations());
    dispatch(addSelectedPrestation(prestation));
    dispatch(setSelectedEtablissement(etablissement));
    navigate(`/details-rdv/${etablissement.id}`);
  };

  const addToGoogleCalendar = () => {
    if (!currentReservation || !etablissement) return;
      // console.log({currentReservation})
    // Format the date for Google Calendar (YYYYMMDDTHHmmss)
    const startDate = new Date(currentReservation.start_time);
    const endDate = new Date(currentReservation.end_time);
    
    
    const formatDate = (date) => {
      const pad = (n) => n < 10 ? '0' + n : n;
      return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}T${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
    };

    const startTime = formatDate(startDate);
    const endTime = formatDate(endDate);
    console.log(startTime)
    // Create event details
    const title = `Rendez-vous ${etablissement?.nom}`;
    const description = `Prestations: ${currentReservation?.prestations_snapshot?.map(p => p.name).join(', ')}\n\nNotes: ${currentReservation.notes || 'Aucune note'}`;
    const location = etablissement?.adresse_postale || '';
   // Get the local time zone (e.g., "Europe/Paris")
   const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Construct Google Calendar URL
    const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${startTime}/${endTime}&details=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}&ctz=${encodeURIComponent(timeZone)}`;

    // Open in a new tab
    window.open(googleCalendarUrl, '_blank');
  };
  return (
    <>
     
     {currentReservation && (
         <Layout
          currentStep={3}
          etablissement={etablissement}
          prestation={currentReservation?.prestations_snapshot}
          recap={true}
          from="facturation"
          conf={false}
          frais={false}
          greyBg={true}
          identification={false}
        >
              <HelmetProvider>
                  <Helmet>
                    <title>Page confirmation réservation </title>
                    <meta
                      name="description"
                      content="confirmation réservation"
                    />
                  </Helmet>
                </HelmetProvider>
           <ConfirmBloc
            title={etablissement?.immediat ? "Votre rendez-vous est confirmé !" : "Votre demande a été envoyée au prestataire !"}
            text={etablissement?.immediat ?
              "Vous recevrez un email de validation avec un récapitulatif. Vous pouvez modifier ou annuler votre rendez-vous jusqu'à 48h à l'avance."
              :
              "Le prestataire doit d'abord accepter valider votre rendez-vous. Vous recevrez un email de validation avec un récapitulatif. Vous pouvez modifier ou annuler votre rendez-vous jusqu'à 48h à l'avance."
            }
            btnText="Ajouter le rdv à mon agenda"
            clickPrimary={addToGoogleCalendar}
            ctaLink={"/compte/rendez-vous"}
            ctatext={"Voir mes demandes"}
          />
          <div className="mt-40">
           
              <PrestationsConfirmBloc buttonAction={buttonAction}/>
         
          </div>
        
        
        </Layout>   )}
     
    </>
  );
};

export default ConfirmPageRendezVous;